<template>
  <div class="pop-login">
    <div class="pop-login-bg"></div>
    <div class="pop-login-con">
      <a href="javascript:;" class="pop-login-close" @click="clickpopShow">关闭</a>
      <form class="yyform">
        <h5 v-if="signStatus < 2">请您填写信息进行预约</h5>
        <h5 v-if="signStatus == 2">请您填写信息进行签到</h5>
        <h5 v-if="signStatus > 2">活动结束</h5>
        <p>
          <input name="name" type="text" placeholder="请填写您的姓名" class="input-txt phone-name" v-model="userLoginForm.nickname" maxlength="18" />
        </p>
        <p>
          <select v-model="userLoginForm.countryId" ref="countryId">
            <option value disabled selected>请选择意向国家/地区</option>
            <option v-for="(item, index) in countryList" :key="index" :value="item.id">{{ item.name }}</option>
          </select>
        </p>
        <p>
          <input name="mobile" type="number" placeholder="请输入手机号" class="input-txt phone-tel" v-model="userLoginForm.mobile" ref="mobile" oninput="if(value.length>11)value=value.slice(0,11)" />
        </p>
        <div :class="isShowCountryCode ? 'namepos on': 'namepos'" @click="showCountryCode()">
          <span class="country-name elips">{{countryName}}</span>
          <span class="country-code">+{{countryCode}}</span>
        </div>
        <input type="hidden" v-model="countryCode" />
        <div class="country-code-box" v-show="isShowCountryCode">
          <span v-for="(item, index) in countryCodeList" :key="index" @click="selectCountry(item.cn,item.code)">
            <i>{{item.cn}}</i>
            <s>+{{item.code}}</s>
          </span>
        </div>
        <p>
          <input type="number" placeholder="请输入验证码" class="input-txt phone-code" v-model="userLoginForm.code" oninput="if(value.length>6)value=value.slice(0,6)" />
          <button type="button" class="yy-form-yzm get-code" @click="userCodeValiate" :disabled="userFormFunc.isDisable">{{userFormFunc.codeText}}</button>
        </p>
        <p>
          <input type="button" class="yy-form-btn" @click="userFormSubmit" :disabled="userFormFunc.isSubmitDisable" value="提交" />
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { sendCode, login, signActivity } from "@/api/home";
import { getQueryString } from "@/assets/js/login.js";
// import { getTimeStatus } from '@/utils/utils'
export default {
  props: {
    // 签到时间状态
    signStatus: {
      type: Number,
      default: 0,
    },
    // 逛展抽奖状态
    prizeStatus: {
      type: Number,
      default: 0,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      // 用户登录表单
      userLoginForm: {
        mobile: "", // 手机号
        code: "", //手机验证码
        countryId: "", // 选中意向国家/地区ID
        nickname: "", //姓名
      },
      countryList: [], // 意向国家/地区
      countryCode: 86, // 国家区号
      countryName: "中国", //国家名称
      countryCodeList: [], // 手机号码归属国家区号
      isShowCountryCode: false,
      //倒计时
      userFormFunc: {
        codeText: "获取验证码",
        telInfo: "",
        isDisable: false,
        isSubmitDisable: false,
        iSucc: false,
      },
    };
  },
  // inject: ["reload"], //注入reload方法
  computed: {},
  methods: {
    // 点击关闭弹窗
    clickpopShow() {
      // 调用父组件的方法
      this.$emit("closeLogin");
    },

    // 点击获取验证码
    async userCodeValiate() {
      if (this.isDisable) {
        return;
      }
      const phoneTel = this.userLoginForm.mobile;
      // const telPartton = /^1\d{10}$/;
      if (phoneTel == "" || phoneTel == "请输入手机号") {
        alert("请输入您的手机号！");
        this.$refs.mobile.focus();
        return false;
      }

      // if (!telPartton.test(phoneTel)) {
      //   alert("手机号码格式不正确");
      //   this.$refs.mobile.focus();
      //   return false;
      // }
      if (!this.countryCode) {
        alert("手机验证码不能为空");
        this.$refs.mobile.focus();
        return false;
      }
      this.userFormFunc.isDisable = true; //点击后立即disable
      const res = await sendCode({
        params: {
          mobile: this.userLoginForm.mobile,
          countryCode: this.countryCode,
        },
      });
      if (!res.succ) {
        alert(res.msg);
        this.userFormFunc.isDisable = false; //验证码获取失败取消disable
      } else {
        let amount = 59;
        let timer = setInterval(() => {
          if (amount <= 0) {
            this.userFormFunc.codeText = "重新获取";
            this.userFormFunc.isDisable = false;
            clearInterval(timer);
          } else {
            this.userFormFunc.codeText = amount--;
          }
        }, 1000);
      }
    },

    // 点击提交表单
    async userFormSubmit() {
      if (this.userFormFunc.isSubmitDisable) {
        return;
      }
      var that = this;
      let phoneTel = that.userLoginForm.mobile;
      let countryId = that.userLoginForm.countryId;
      let nickname = that.userLoginForm.nickname;
      let code = that.userLoginForm.code;
      // let telPartton = /^1\d{10}$/;

      if (nickname == "") {
        alert("请输入您的姓名！");
        return false;
      }

      if (phoneTel == "" || phoneTel == "请输入手机号") {
        alert("请输入您的手机号！");
        that.$refs.mobile.focus();
        return false;
      }
      if (countryId == "" || countryId == "请选择意向国家/地区") {
        alert("请选择意向国家/地区！");
        that.$refs.countryId.focus();
        return false;
      }
      // if (!telPartton.test(phoneTel)) {
      //   alert("手机号码格式不正确");
      //   that.$refs.mobile.focus();
      //   return false;
      // }
      if (!code) {
        alert("请输入验证码");
        return false;
      }
      if (code.length < 6) {
        alert("验证码格式");
        return false;
      }
      that.userFormFunc.isSubmitDisable = true; //提交按钮可用
      this.userLoginForm.countryCode = this.countryCode;
      let apiData = "";
      let ticket = getQueryString("ticket");
      let res;
      if (ticket != null) {
        res = await login({
          ...this.userLoginForm,
          ticket,
        });
      } else {
        res = await login(this.userLoginForm);
      }

      if (!res.succ) {
        alert(res.msg);
        that.userFormFunc.isSubmitDisable = false; //提交按钮可用
      } else {
        // 登录成功
        if (this.signStatus == 2) {
          this.getSign();
        }
        // 逛展抽奖开始才存储时间
        window.localStorage.setItem("loginTime", Date.now());
        that.userFormFunc.isSubmitDisable = true; //提交按钮不可用
        that.userFormFunc.iSucc = true; //显示成功
        let telStr = phoneTel.slice(-7, -3);
        that.userFormFunc.telInfo = phoneTel.replace(telStr, "****");
        this.isLogin = true;
        this.clickpopShow();
        this.$emit("success");
      }
    },

    // 调用签到接口
    async getSign() {
      const res = await signActivity({
        expoId: this.expoId,
      });
    },

    //获取国家列表
    getCountryList() {
      let baseUrl = "/aec"; // 代理
      if (
        window.location.hostname == "m0.eicchannel.com" ||
        window.location.hostname == "m.eicchannel.com"
      ) {
        baseUrl = "https://api-kt.eiceducation.com.cn";
      }
      this.$axios
        .get(baseUrl + "/country/getCountryList")
        .then((res) => {
          if (res.data.succ) {
            let list = [];
            list = res.data.results;
            //console.log(res);
            for (let i = 0; i < list.length; i++) {
              if (list[i].name == "未确定") {
                list[i].name = "其他";
              }
            }
            this.countryList = list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //手机号码归属国家区号
    getCountryCodeList() {
      let baseUrl = "/aec"; // 代理
      if (
        window.location.hostname == "m0.eicchannel.com" ||
        window.location.hostname == "m.eicchannel.com"
      ) {
        baseUrl = "https://api-kt.eiceducation.com.cn";
      }
      this.$axios
        .get(baseUrl + "/country/getCountryCodeList")
        .then((res) => {
          if (res.data.succ) {
            let codeList = [];
            codeList = res.data.results;
            this.countryCodeList = codeList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //用户选择国家
    selectCountry(name, code) {
      this.countryName = name;
      this.countryCode = code;
      this.isShowCountryCode = false;
    },
    //用户下拉显示国家区号列表
    showCountryCode() {
      this.isShowCountryCode = !this.isShowCountryCode;
    },
  },
  async created() {
    console.log(this.prizeStatus);
    this.getCountryList();
    this.getCountryCodeList();
  },
};
</script>


<style scoped>
.pop-login {
  width: 100%;
  height: 100%;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
}
.pop-login-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.7;
}
.exop-yy-pop-close {
  width: 30px;
  height: 30px;
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  background: url(~@/assets/images/pop_close_btn.png) no-repeat;
  text-indent: -9999px;
}
.pop-login-con {
  width: 5rem;
  /* height: 3rem; */
  padding: 0.3rem 0 0.1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  margin-top: -2rem;
  margin-left: -2.5rem;
  border-radius: 0.16rem;
  text-align: center;
}
.pop-login-con .yyform {
  width: 3.5rem;
  margin: 0 auto;
}
.pop-login-con .yyform h5 {
  width: 3rem;
  height: 0.3rem;
  margin: auto;
  background: url(~@/assets/images/pop_login_icon1.png) no-repeat left center;
  background-size: 0.3rem 0.3rem;
  padding-left: 0.3rem;
  font-size: 0.2rem;
  line-height: 0.3rem;
  font-weight: 4;
  margin-bottom: 0.3rem;
  font-weight: 700;
}
.pop-login-close {
  width: 0.5rem;
  height: 0.5rem;
  display: block;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  background: url(~@/assets/images/pop_close_btn.png) no-repeat;
  background-size: 100% 100%;
  text-indent: -9999rem;
}
.pop-login-con form input {
  outline: none;
}
.pop-login-con p {
  height: 0.42rem;
  margin-bottom: 0.2rem;
}
.pop-login-con p.ts {
  margin-bottom: 0.35rem;
}
.pop-login-con p .input-txt {
  width: 100%;
  height: 0.44rem;
  display: block;
  border: 0;
  background: #f5f5f5;
  border-radius: 0.22rem;
  padding: 0 0.18rem;
  box-sizing: border-box;
  font-size: 0.22rem;
  line-height: 0.44rem;
  -moz-appearance: textfield;
}
.pop-login-con p .input-txt.phone-tel {
  padding: 0 0.18rem 0 1.6rem;
}
.pop-login-con p select {
  width: 100%;
  height: 0.44rem;
  display: block;
  border: 0;
  background: #f2f5fb;
  border-radius: 0.1rem;
  padding: 0 0.18rem;
  box-sizing: border-box;
  font-size: 0.22rem;
  line-height: 0.44rem;
  background: #f5f5f5 url(~@/assets/images/arr_select.png) no-repeat right
    center;
  background-size: 0.3rem 0.3rem;
  color: #757575;
}
.pop-login-con p .input-txt.phone-code {
  width: 1.85rem;
  margin-right: 0.2rem;
  float: left;
}
.pop-login-con .namepos {
  width: 1.3rem;
  height: 0.38rem;
  display: block;
  position: absolute;
  top: 2.18rem;
  left: 0.92rem;
  border-right: 1px solid #e5e5ea;
  line-height: 0.38rem;
  font-size: 0.22rem;
  color: #7e7c94;
  overflow: hidden;
  zoom: 1;
  background: url(~@/assets/images/arr_select2.png) right 0.11rem no-repeat;
  background-size: 0.21rem auto;
}
.pop-login-con .namepos span.country-name {
  width: 40%;
  display: block;
  float: left;
}
.pop-login-con .namepos span.country-code {
  width: 40%;
  display: block;
  float: left;
}
.pop-login-con .namepos.on {
  background: url(~@/assets/images/arr_select2a.png) right 0.11rem no-repeat;
  background-size: 0.21rem auto;
}
.pop-login-con .country-code-box {
  width: 3.6rem;
  height: 3.5rem;
  padding: 0.1rem 0.2rem;
  border: 1px solid #cdcdcd;
  background: #fff;
  position: absolute;
  top: 2.56rem;
  left: 50%;
  margin-left: -1.8rem;
  overflow: auto;
  border-radius: 0.1rem;
  z-index: 999;
}
.pop-login-con .country-code-box span {
  display: block;
  height: 0.55rem;
  border-bottom: 1px solid #eee;
  font-size: 0.24rem;
  line-height: 0.55rem;
  color: #666;
  overflow: hidden;
  zoom: 1;
  cursor: pointer;
}
.pop-login-con .country-code-box span i {
  width: 70%;
  display: block;
  float: left;
  font-style: normal;
  text-align: left;
}
.pop-login-con .country-code-box span s {
  width: 30%;
  display: block;
  float: right;
  text-decoration: none;
  text-align: right;
}

.pop-login-con .yy-form-yzm {
  width: 1.43rem;
  height: 0.44rem;
  display: block;
  float: left;
  border: 0.02rem solid #2157e1;
  border-radius: 0.22rem;
  font-size: 0.22rem;
  /* font-weight: 700; */
  color: #18389f;
  background: #fff;
  font-weight: 700;
  cursor: pointer;
  outline: none;
}
.pop-login-con .yy-form-yzm:disabled {
  background: #ccc;
  color: #fff;
  border: 0.02rem solid #ccc;
}
.pop-login-con .yy-form-btn {
  width: 1.8rem;
  height: 0.46rem;
  display: block;
  margin: 0 auto;
  border: 0;
  background: #2157e1;
  cursor: pointer;
  color: #fff;
  outline: none;
  font-size: 0.22rem;
  line-height: 0.46rem;
  border-radius: 0.23rem;
}
.pop-login-con .yy-form-btn:disabled {
  background: #ccc;
}
</style>
